import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['open', 'closed'];

  get isOpen() {
    return !this.openTarget.hidden;
  }

  get tracksController() {
    return this.application.getControllerForElementAndIdentifier(
      this.element.closest('[data-controller="tracks"]'),
      'tracks',
    );
  }

  handleTrackEditClick() {
    this.tracksController.closeAll();

    this.closedTarget.hidden = true;
    this.openTarget.hidden = false;

    this.tracksController.updateOpenTracks();
  }

  close() {
    this.closedTarget.hidden = false;
    this.openTarget.hidden = true;

    this.tracksController.updateOpenTracks();
  }
}
